import React from 'react';

const SideNav = () => {
  return (
    <aside className="fixed left-0 top-20 h-[calc(100vh-5rem)] w-20 rounded-r-2xl bg-surface/60 backdrop-blur-2xl shadow-2xl z-40 hidden md:block">
      <div className="flex flex-col items-center py-8 h-full">
        <div className="group cursor-pointer flex flex-col items-center transition-all duration-300 ease-in-out p-3 rounded-xl bg-primary-container/20 text-primary">
          <span className="material-symbols-outlined">layers</span>
          <span className="text-[10px] uppercase tracking-tighter mt-1 font-label">Map</span>
        </div>
      </div>
    </aside>
  );
};

export default SideNav;
